function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.9998 8.54446L12.9765 5.25263C12.0336 3.71849 10.3563 2.70703 8.44546 2.70703C5.50686 2.70703 3.125 5.08905 3.125 8.0283C3.125 9.62347 3.82843 11.0521 4.95297 12.0331L5.01393 12.0863L14.9999 22.0727L24.9859 12.0863L25.0469 12.0331C26.1715 11.052 26.875 9.62338 26.875 8.0283C26.875 5.08944 24.4926 2.70703 21.5536 2.70703C19.643 2.70703 17.9665 3.71818 17.0232 5.25274L14.9998 8.54446ZM13.393 2.14108C12.0566 1.01305 10.332 0.332031 8.44546 0.332031C4.19486 0.332031 0.75 3.7777 0.75 8.0283C0.75 10.3425 1.77549 12.4129 3.39172 13.8228L14.2976 24.7292C14.4838 24.9154 14.7364 25.0201 14.9999 25.0201C15.2634 25.0201 15.516 24.9154 15.7022 24.7292L26.6081 13.8228C28.2244 12.4129 29.25 10.3425 29.25 8.0283C29.25 3.7777 25.8042 0.332031 21.5536 0.332031C19.667 0.332031 17.9429 1.01302 16.6068 2.141C15.9772 2.67257 15.4337 3.3034 14.9999 4.00901C14.5662 3.30343 14.0227 2.67263 13.393 2.14108Z",
  fill: "#943FA1"
});

var SvgFavIcon = function SvgFavIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFavIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FavIcon.c3998f82.svg";
export { ForwardRef as ReactComponent };